import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedCategories from './components/FeaturedCategories';
import SEOContentSection from './components/SEOContentSection';
import TrustSection from './components/TrustSection';
import CTASection from './components/CTASection';

const siteUrl = import.meta.env.VITE_SITE_URL;
const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Kakobuy Spreadsheet Finds',
  url: siteUrl,
  description: 'The ultimate kakobuy spreadsheet resource for smart product research. Explore thousands of trending products, verified finds, comparison guides, and spreadsheet resources.',
  inLanguage: 'en',
  publisher: {
    '@type': 'Organization',
    name: 'Kakobuy Spreadsheet Finds',
    url: siteUrl,
    logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png',
  },
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <article>
          <CategoryGrid />
        </article>
        <section>
          <FeaturedCategories />
        </section>
        <article>
          <SEOContentSection />
        </article>
        <section>
          <TrustSection />
        </section>
        <section>
          <CTASection />
        </section>
      </main>
      <Footer />
    </>
  );
}